"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const axios_1 = __importDefault(require("axios"));
let cancelListToken;
let cancelTotalToken;
class UserHistory extends base_1.default {
    getUserHistory(data) {
        if (typeof cancelListToken != typeof undefined) {
            cancelListToken.cancel("Operation canceled due to new request.");
        }
        cancelListToken = this.Axios.CancelToken.source();
        return this.post('/user-history/list', data);
    }
    getUserMoneyEntries(data) {
        if (typeof cancelListToken != typeof undefined) {
            cancelTotalToken.cancel("Operation canceled due to new request.");
        }
        cancelTotalToken = this.Axios.CancelToken.source();
        return this.post('/user-history/total', data);
    }
    getCaseDetails(data) {
        return this.post(`/user-history/${data.id}`, { caseType: data.type });
    }
    downloadFile(data = {}, auth = true) {
        const token = localStorage.getItem('token');
        if (!token && auth)
            return null;
        return axios_1.default({
            method: 'post',
            url: `${window.AppearMe.appConfigs.url}/create-transactions-file`,
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                'appearme-token': auth ? `${token === null || token === void 0 ? void 0 : token.replace('%20', ' ')}` : ''
            },
            data: data,
            responseType: "blob"
        }).then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = 'payment_report.pdf';
            a.click();
        });
    }
}
exports.default = new UserHistory();
